import React, { Component } from "react";
import { Form, Modal, Col, Row } from "antd";
import { AddNewCustomer } from "../../../user/add-customer/add-customer";
import { AddNewAdmin } from "../../../user/add-admin/add-admin";
import { CUSTOMER_CODE } from "../../../../../common/utils/static-data";
import { submit } from "../../../user/user-event";
import { apiCustomer } from "../../../../../api/api-customer";

const initialValues = {
  customer_type: "CT002",
  card_type: 1,
  accountStatus: 0,
  password: "Cus-0000",
};
export class AddCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabledOk: false,
      visible: false,
      type: "NEW",
      enterprise: true,
      checkAccountStatus: true,
      checkEditPass: false,
    };
  }

  async componentDidMount() {}

  visiableModal = async (visible) => {
    this.setState({ visible });
    const result = await apiCustomer.getEnterpriseCustomerName();
    if (result.status === "success") {
      this.form.setFieldsValue({
        signinName: result.data,
      });
    } else {
      alert("error", result.status);
    }
  };

  visiableOKButton = (visible) => {
    this.setState({ disabledOk: visible });
  };

  handleOk = () => {
    const IS_MODAL = true;
    submit(this, IS_MODAL, this.visiableOKButton, this.setCustomerOnModal);
  };

  setCustomerOnModal = (customer) => {
    this.props.setCustomerOnModal(customer);
    this.form.setFieldsValue({
      name: "",
      address: "",
      tax_code: "",
      bank_account_holder: "",
      bank_name: "",
      bank_account_number: "",
      admin_name: "",
      mobile: "",
      email: "",
      department: "",
      signinName: "",
    });
    this.visiableModal(false);
  };

  handleCancel = () => {
    this.form.setFieldsValue({
      name: "",
      address: "",
      tax_code: "",
      bank_account_holder: "",
      bank_name: "",
      bank_account_number: "",
      admin_name: "",
      mobile: "",
      email: "",
      department: "",
      signinName: "",
    });
    this.visiableModal(false);
  };

  onChangeText = (feild, value) => {
    this.setState({
      user: {
        ...this.state.user,
        [feild]: value,
      },
    });
  };

  onChangeForm = (feild, value) => {
    this.form.setFieldsValue({
      [feild]: value,
    });
  };

  onChangeFormValues = (values) => {
    this.form.setFieldsValue({
      ...values,
    });
  };

  getCustomerType = () => {
    if (!this.form) {
      return CUSTOMER_CODE.enterprise;
    }
    return this.form.getFieldValue("customer_type");
  };

  setEnterprise = async (enterprise) => {
    this.setState({ enterprise });
    if (enterprise) {
      const result = await apiCustomer.getEnterpriseCustomerName();
      if (result.status === "success") {
        this.form.setFieldsValue({
          signinName: result.data,
        });
      } else {
        alert("error", result.status);
      }
    } else {
      const result = await apiCustomer.getIndividualCustomerName();
      if (result.status === "success") {
        this.form.setFieldsValue({
          signinName: result.data,
        });
      } else {
        alert("error", result.status);
      }
    }
  };

  validateForm = () => {
    if (this.form) {
      const fieldsObject = this.form.getFieldsError();
      const fieldsErros = fieldsObject
        .filter((value) => {
          if (value.errors.length > 0) {
            return true;
          }
        })
        .map((value) => {
          if (value.name.length > 0) {
            return value.name[0];
          }
        });
      this.form.validateFields(fieldsErros);
    }
  };

  setAccountStatus = (checkAccountStatus) => {
    this.setState({ checkAccountStatus });
  };

  render() {
    const { visible, enterprise, disabledOk } = this.state;
    const layout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };

    return (
      <Modal
        wrapClassName={"customer-modal"}
        title={"Thêm khách hàng mới"}
        visible={visible}
        maskClosable={false}
        onOk={() => this.handleOk()}
        cancelText="Huỷ"
        confirmLoading={disabledOk}
        okText={"Thêm khách hàng"}
        onCancel={this.handleCancel}
      >
        <Form
          style={{ padding: "0px 10px" }}
          initialValues={initialValues}
          scrollToFirstError
          ref={(ref) => (this.form = ref)}
          {...layout}
        >
          <Row gutter={24}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <AddNewCustomer
                editable={true}
                editPage={false}
                isModal
                enterprise={enterprise}
                setEnterprise={this.setEnterprise}
                ref={(ref) => (this.newCustomer = ref)}
                validate={this.validateForm}
                onChangeForm={this.onChangeForm}
                onChangeFormValues={this.onChangeFormValues}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <div style={{ position: "relative" }}>
                <AddNewAdmin
                  editable={true}
                  editPage={false}
                  enterprise={enterprise}
                  setEnterprise={this.setEnterprise}
                  setAccountStatus={this.setAccountStatus}
                  typeOption="create_new"
                  getCustomerType={this.getCustomerType}
                  onChangeFormValues={this.onChangeFormValues}
                  ref={(ref) => (this.adminUser = ref)}
                  validate={() => this.form.validateFields()}
                />
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}
